<script setup lang="js">

import ContextWhile from "@/components/ContextWhile.vue";
import ContextTitle from "@/components/ContextTitle.vue";
import {reactive, ref} from "vue";
import CompanyTitle from "@/components/CompanyTitle.vue";
import SubButton from "@/components/SubButton.vue";
import {ElForm, ElFormItem, ElInput, ElMessage} from 'element-plus';
import router from "@/router";
import axios from "axios";
const datas=ref({
  cooperate:'',
  userName:'',
  phone:'',
  email:'',
  companyName:'',
  money:'',
  employment:'',
  labor:'',
  demand:[],
  cycle:[],

})
const formRef = ref(null);
const rules = ref({
  cooperate: [
    { required: true, message: '请选择合作驱动力', trigger: 'blur' },
  ],
  money: [
    { required: true, message: '请输入月招聘成本', trigger: 'blur' },
  ],
  employment: [
    { required: true, message: '请输入灵活用工占比', trigger: 'blur' },
  ],
  labor: [
    { required: true, message: '请输入年均劳务纠纷', trigger: 'blur' },
  ],
  demand: [
    { required: true, message: '请选择系统对接需求', trigger: 'blur' },
  ],
  cycle: [
    { required: true, message: '请选择期待见效周期', trigger: 'blur' },
  ],
  companyName: [
    { required: true, message: '请输入企业名称', trigger: 'blur' },
  ],
  userName: [
    { required: true, message: '请输入联系人', trigger: 'blur' },
  ],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { length: 11, message: "手机号11位", trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入邮件地址', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ]
});
const companyClick=()=>{
  console.log(datas.value)
  formRef.value.validate((valid) => {
    if (valid) {
      axios({
        method:"post",
        url:"http://localhost:8082/official/companyQuestionnaire",
        headers:{tenantId:'000000'},
        data:datas.value
      }).then((res)=>{
        if (res.data.code === 200){
          ElMessage.primary('上传成功')
          router.back();
        }else {
          ElMessage.error('上传失败，请重试')
        }
      })
    } else {
      return false;
    }
  });
}
</script>

<template>
  <div>
    <context-while>
      <el-form
          ref="formRef"
          :rules="rules"
          :model="datas"
          label-width="auto"
      >
        <context-title text="企业侧诊断问卷"></context-title>
        <CompanyTitle title="1.合作驱动力"/>
        <div>
          <el-form-item prop="cooperate">
            <el-radio-group v-model="datas.cooperate" class="flex flex-row" >
              <el-radio value="1" size="large">降低用工成本</el-radio>
              <el-radio value="2" size="large">解决季节性用工荒</el-radio>
              <el-radio value="3" size="large">规避劳动纠纷风险</el-radio>
              <el-radio value="4" size="large">获取政府补贴</el-radio>
            </el-radio-group>
          </el-form-item>

          <CompanyTitle title="2.量化痛点"/>
          <div class="w-full lg:w-1/3 md:w-full ">
            <div class="w-full flex justify-between"><div>指标</div> <div>当前值</div></div>
          </div>
          <div class="w-full lg:w-1/3 md:w-full items-center ">
            <div class="w-full flex justify-between items-center ">
              <div class="">月均招聘成本</div>
              <div class="flex text-center items-center" >
                <el-form-item prop="money">
                  <el-input
                      autosize
                      v-model="datas.money"
                      type="number"
                      :style="{
                  '--el-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-width': '0px',
                  '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-hover-border-width': '0px',
                }"
                      class="border-b-[1px]  border-black border-dotted"
                  />
                </el-form-item>

                <text>元</text>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/3 md:w-full items-center ">
            <div class="w-full flex justify-between items-center ">
              <div class="">灵活用工占比</div>
              <div class="flex text-center items-center" >
                <el-form-item prop="employment">
                  <el-input
                      autosize
                      v-model="datas.employment"
                      type="number"
                      :style="{
                  '--el-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-width': '0px',
                  '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-hover-border-width': '0px',
                }"
                      class="border-b-[1px]  border-black border-dotted"
                  />
                </el-form-item>

                <text>%</text>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/3 md:w-full items-center ">
            <div class="w-full flex justify-between items-center ">
              <div class="">年均劳务纠纷</div>
              <div class="flex text-center items-center" >
                <el-form-item prop="labor">
                  <el-input
                      autosize
                      type="number"
                      v-model="datas.labor"
                      :style="{
                  '--el-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-width': '0px',
                  '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-hover-border-width': '0px',
                }"
                      class="border-b-[1px]  border-black border-dotted"
                  />
                </el-form-item>

                <text>起</text>
              </div>
            </div>
          </div>
          <CompanyTitle title="3.系统对接需求"/>
          <el-form-item prop="demand">
            <el-checkbox-group v-model="datas.demand">
              <el-checkbox label="现有HR系统对接" value="1"/>
              <el-checkbox label="财务系统打通" value="2"/>
              <el-checkbox label="独立部署" value="3"/>
            </el-checkbox-group>
          </el-form-item>


          <CompanyTitle title="4.期待见效周期"/>
          <el-form-item prop="cycle">
            <el-checkbox-group v-model="datas.cycle">
              <el-checkbox label="1个月内" value="1"/>
              <el-checkbox label="季度见效" value="2"/>
              <el-checkbox label="年度规划" value="3"/>
            </el-checkbox-group>
          </el-form-item>

        </div>
        <div class="w-full bg-[#161981] h-[0.1rem] px-24"></div>
        <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
          <div class="text-2xl md:text-2xl lg:text-3xl">企业名称：</div>
          <div class="w-2/3   lg:mt-3">
            <el-form-item prop="companyName">
              <el-input
                  autosize
                  type="textarea"
                  v-model="datas.companyName"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black w-full"
              />
            </el-form-item>

          </div>
        </div>
        <div class="lg:flex lg:justify-between">
          <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
            <div class="text-2xl md:text-2xl lg:text-3xl">联系人：</div>
            <div class="w-2/3   lg:mt-3">
              <el-form-item prop="userName">
                <el-input
                    autosize
                    type="textarea"
                    v-model="datas.userName"
                    :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                    class="border-b-[1px]  border-black w-full"
                />
              </el-form-item>

            </div>
          </div>

          <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
            <div class="text-2xl md:text-2xl lg:text-3xl">联系电话：</div>
            <div class="w-2/3   lg:mt-3">
              <el-form-item prop="phone">
                <el-input
                    autosize
                    v-model="datas.phone"
                    type="textarea"
                    :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                    class="border-b-[1px]  border-black w-full"
                />
              </el-form-item>

            </div>
          </div>




        </div>
        <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
          <div class="text-2xl md:text-2xl lg:text-3xl">邮件地址：</div>
          <div class="w-2/3   lg:mt-3">
            <el-form-item prop="email">
              <el-input
                  autosize
                  type="textarea"
                  v-model="datas.email"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black w-full"
              />
            </el-form-item>
          </div>
        </div>
        <sub-button @click="companyClick"></sub-button>
      </el-form>

    </context-while>

  </div>
</template>

<style scoped>
</style>
